import type { CareType } from '@/types/interfaces/care'

type CareUpdater = (newCare: CareType | null) => void

let careUpdater: CareUpdater | null = null

/** Registers the CareProvider setter so RTK Query can sync after a care-plan fetch. */
export function registerCareContextUpdater(updater: CareUpdater | null) {
    careUpdater = updater
}

/** Pushes care into CareProvider from non-React callers such as RTK Query. */
export function syncCareContext(newCare: CareType | null) {
    careUpdater?.(newCare)
}
